import { isTestAccount } from "@/lib/is-test-account";

/**
 * Prod only: dev keeps its test tenants so Brain can still be tried there.
 * Same prod ref as .env.production.
 */
export const BRAIN_HIDES_TEST_DATA = (
  import.meta.env.VITE_SUPABASE_URL ?? ""
).includes("cnphwhynfezadsobiixa");

// ponytail: demo buildings are recognised by name ("Preziosastraße Demo",
// "Testing updated"). Move to a property flag if real names ever collide.
const DEMO_PROPERTY = /\b(demo|test|testing)\b/i;

/**
 * A row Brain hides on prod: a test/CoLiviq tenant (is-test-account's rules
 * plus the admins' test_account_filters) or anything in a demo building.
 */
export function isBrainTestRow(
  email: string | null | undefined,
  propertyTitle: string | null | undefined,
  testEmails: readonly string[]
): boolean {
  return (
    isTestAccount(email, testEmails) || DEMO_PROPERTY.test(propertyTitle ?? "")
  );
}
